import PropTypes from 'prop-types'
import React from 'react'
import SectionItem from 'containers/SectionItem'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'

/**
 * @param instance
 * @param isHorizontal
 * @param analyticEventPrefix
 * @returns {JSX.Element}
 * @constructor
 */
function RecommendedItem ({
  instance,
  isHorizontal,
  analyticEventPrefix
}) {
  return (
    <div style={{ marginRight: STYLES_MARGIN.SMALL }}>
      <SectionItem
        hasFixedWidth
        instance={instance}
        isHorizontal={isHorizontal}
        analyticEventPrefix={analyticEventPrefix}
      />
    </div>
  )
}

RecommendedItem.propTypes = {
  instance: PropTypes.object
}

export default RecommendedItem
